import { UseTimeZone } from '../../../../../../common/hooks/useTimeZone'
import { FORMAT, formatDateTime } from '../../../../../../helpers/datetime'

export const ReportingYear = ({ val, locale }) => {
  const timeZone = UseTimeZone()

  return formatDateTime(val, FORMAT.YEAR, locale, timeZone)
}
